import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userDetailState: {},
};

export const userDetailStateSlice = createSlice({
  name: 'userDetail',
  initialState,
  reducers: {
    setUserDetailState: (state, actions) => {
      const { key, value } = actions.payload;
      if (Object.prototype.hasOwnProperty.call(initialState, key)) {
        state[key] = value;
      }
    },
    clearUserDetailState: (state) => {
      state.userDetailState = {};
    },
  },
});

export const { setUserDetailState, clearUserDetailState } = userDetailStateSlice.actions;

export default userDetailStateSlice.reducer;
